<template>
  <div id="trs-main" class="bo-register">
    <div class="container-bo-register">
      <div class="page">
        <div class="page-ct">
          <div class="section">
            <div class="alert alert-danger" v-if="model.errorMessage != null">{{$t(model.errorMessage)}}</div>
            <div class="section-inner">
              <form class="form-horizontal" v-show="!isConfirm" name="boRegisForm" id="boRegisForm" novalidate>
                <div class="panel-agreement">
                  <div class="box-ct">
                    <div style="margin-bottom: 2%">
                      <img style="height: 33px" :src="boBlockLogo">
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.agreement.regulationFX_BO_CryptoFX') }}</h2>
                      <div class="section-ct">
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <ul class="list-unstyled">
                                  <li><a :href="minStHome + 'pdf/regulation_boattention.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationBoattention') }}</a></li>
                                  <li><a :href="minStHome + 'pdf/regulation_overview_op.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationOverviewOp') }}</a></li>
                                  <li><a :href="minStHome + 'pdf/regulation_rules_op.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationRulesOp') }}</a></li>
                                </ul>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.accept")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.agreement.bo.confirmOptionTrading') }}</h2>
                      <div class="section-ct section-ct-group">
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>
                                  {{ $t('label.agreement.bo.confirmContent1') }}
                                </p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent2')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent3')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent4')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent5')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent6')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent7')"></p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>
                                  {{ $t('label.agreement.bo.confirmContent8') }}
                                </p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>
                                  {{ $t('label.agreement.bo.confirmContent9') }}
                                </p>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{$t("customer.agree.yes")}}</a>
                                <a class="btn btn-default" @click="[btnDefaultClick($event), openCancelModal()]">{{$t("customer.agree.no")}}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 class="section-title">{{$t("bo_regis.investment_financial")}}</h2>
                <div class="form-group overflow-auto">
                  <label class="col-sm-2 control-label pl-0 float-left"><strong>{{$t("trs.front.bo.registration.label.purpose")}}</strong></label>
                  <div class="col-sm-6 float-left">
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.shortTerm" :true-value="'1'" :false-value="'0'" :required="!isSelectBoInvest()">
                        {{$t("trs.front.bo.registration.label.short_term")}}
                      </label>
                    </div>
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.dispersion" :true-value="'1'" :false-value="'0'" :required="!isSelectBoInvest()">
                        {{$t("trs.front.bo.registration.label.dispersion")}}</label>
                    </div>
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.hedge" :true-value="'1'" :false-value="'0'" :required="!isSelectBoInvest()">
                        {{$t("trs.front.bo.registration.label.hedge")}}
                      </label>
                    </div>
                    <div class="clear-both"></div>
                    <div class="toggle-div-ct" v-if="input.hedge === '1'">
                      <div class="row">
                        <div class="col-sm-6 col-md-5">
                          <select class="form-control" v-model="input.hedgeType" required name="hedgeType" @change="changeDirtyHedgeType">
                            <option v-for="item in mapHedgeType" :key="item.key" :value="item.key">{{$t(item.value)}}</option>
                          </select>
                          <div v-if="(clickConfirm || dirtyHedgeType) && !$v.input.hedgeType.required" class="error-messages ng-active">
                            <div>{{$t("MSG_TRS_NAF_0004_BO", {param1 : $t("profile.label.bo_investment_purpose")})}}</div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <select class="form-control" v-model="input.hedgeAmount" name="hedgeAmount" required @change="changeDirtyHedgeAmount">
                            <option v-for="item in listFinalAssets" :key="item.key" :value="item.key">{{$t(item.value)}}</option>
                          </select>
                          <div v-if="(clickConfirm || dirtyHedgeAmount) && !$v.input.hedgeAmount.required" class="error-messages ng-active">
                            <div>{{$t("MSG_TRS_NAF_0004_BO", {param1 : $t("profile.label.bo_investment_purpose")})}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="checkbox error-messages ng-active" v-if="clickConfirm && errorMessageRequired != null">
                      {{$t(errorMessageRequired)}}
                    </div>
                  </div>
                </div>
                <div class="form-group overflow-auto">
                  <label class="col-sm-2 control-label pl-0 float-left"><strong>{{$t("trs.front.bo.registration.label.max_loss_amount")}}</strong></label>
                  <div class="col-sm-4 col-md-3 float-left">
                    <div class="input-group">
                      <input type="text" class="form-control moneyMask" v-model="input.maxLossAmount"
                             name="boLossMaxAmount" @keyup="invalidSelfAssets()" required v-numbers-only>
                      <span class="input-group-addon currency-addon ml-2 mt-2">{{$t("label.max_loss_amount.unit")}}</span>
                    </div>
                    <div v-if="clickConfirm && !$v.input.maxLossAmount.required" class="error-messages ng-active">
                      <div>{{$t("MSG_TRS_NAF_0004_param", {param1 : $t("profile.label.bo_loss_maximum_amount")})}}
                      </div>
                    </div>
                    <div class="checkbox error-messages ng-active" v-if="errorMessageSelfAssets != null">
                      {{$t(errorMessageSelfAssets)}}
                    </div>
                  </div>
                </div>

                <hr>
                <div class="alert alert-warning">
                  <div>
                    {{$t("bo_regis.note")}}
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-action">
                    <button class="btn btn-lg btn-light btn-padding-lg mr-1" @click="cancel()">{{$t("btn.go_to_cancel")}}
                    </button>
                    <button class="btn btn-lg btn-success btn-padding-lg ml-1" @click.prevent="confirmRegist()" id="btnSave" disabled>{{$t("btn.go_to_confirm")}}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <!-- confirm screen-->
            <div class="section-inner" v-if="isConfirm">
              <form class="form-horizontal">
                <div class="panel-agreement">
                  <div class="box-ct">
                    <div style="margin-bottom: 2%">
                      <img style="height: 33px" :src="boBlockLogo">
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.agreement.regulationFX_BO_CryptoFX') }}</h2>
                      <div class="section-ct">
                        <div class="section-box">
                          <div class="box-item answered">
                            <div class="left-part">
                              <div class="section-box-item">
                                <ul class="list-unstyled">
                                  <li><a :href="minStHome + 'pdf/regulation_boattention.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationBoattention') }}</a></li>
                                  <li><a :href="minStHome + 'pdf/regulation_overview_op.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationOverviewOp') }}</a></li>
                                  <li><a :href="minStHome + 'pdf/regulation_rules_op.pdf'" target="_blank">
                                    <i class="far fa-file-pdf f-s-14"/> {{ $t('label.agreement.bo.regulationRulesOp') }}</a></li>
                                </ul>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("btn.agreement.news.agree")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.agreement.bo.confirmOptionTrading') }}</h2>
                      <div class="section-ct section-ct-group">
                        <div class="section-box">
                          <div class="box-item answered">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>
                                  {{ $t('label.agreement.bo.confirmContent1') }}
                                </p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent2')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent3')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent4')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent5')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent6')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p v-html="$t('label.agreement.bo.confirmContent7')"></p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>
                                  {{ $t('label.agreement.bo.confirmContent8') }}
                                </p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <p>{{ $t('label.agreement.bo.confirmContent9') }}</p>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{$t("customer.agree.yes")}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h2 class="section-title">{{$t("bo_regis.investment_financial")}}</h2>
                </div>
                <div class="form-group overflow-auto">
                  <label class="col-sm-2 control-label pl-0 float-left"><strong>{{$t("trs.front.bo.registration.label.purpose")}}</strong></label>
                  <div class="col-sm-6 float-left">
                    <p class="form-control-static" v-if="input.shortTerm === '1'">
                      {{$t("trs.front.bo.registration.label.short_term")}}</p>
                    <p class="form-control-static" v-if="input.dispersion === '1'">
                      {{$t("trs.front.bo.registration.label.dispersion")}}</p>
                    <p class="form-control-static" v-if="input.hedge === '1'">
                      {{$t("trs.front.bo.registration.label.hedge")}}</p>
                    <p class="form-control-static" v-if="input.hedge === '1'">{{$t(hedgeType)}}</p>
                    <p class="form-control-static" v-if="input.hedge === '1'">{{$t(hedgeAmount)}}</p>
                  </div>
                </div>
                <div class="clear-both"></div>
                <div class="form-group overflow-auto">
                  <label class="control-label col-sm-2 pl-0 float-left"><strong>{{$t("trs.front.bo.registration.label.max_loss_amount")}}</strong></label>
                  <div class="col-sm-3 float-left">
                    <p class="form-control-static">{{input.maxLossAmount}}{{$t("label.max_loss_amount.unit")}}</p>
                  </div>
                </div>
                <hr>
                <div class="form-action">
                  <button class="btn btn-lg btn-default btn-padding-lg mr-1" @click="backToInput()">{{$t("btn.back")}}</button>
                  <button type="button" class="btn btn-lg btn-success btn-padding-lg ml-1" @click="saveRegist()" id="btnRegist">
                    {{$t("customer.agree.accept")}}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {required, requiredIf} from "vuelidate/lib/validators";
import IConstants from "@/common/constants/IConstants";
import ServiceUtils from "@/common/utils/ServiceUtils.js";
import $ from "jquery";
import ModalPlugin from "../../common/plugins/ModalPlugin";
import * as HEADER_TYPE from "@/store/modules/header/type";
import * as NEWS_TYPE from "@/store/modules/news/type";
import {createNamespacedHelpers} from "vuex";
import offModalEvent from "@/common/mixins/offModalEvent";
import postDocTemplateMixin from "@/common/mixins/postDocTemplate";

const {mapActions: mapHeaderAction} = createNamespacedHelpers("header");
const {mapActions: mapNewsActions} = createNamespacedHelpers('news');

export default {
    data() {
        return {
            SERVICE_NAME: "boRegistration",
            mapHedgeType: IConstants.listBoPurposeHedgeType,
            boBlockLogo: IConstants.LINK_ASSETS.BO_BLOCK_LOGO,
            dirtyHedgeType: false,
            dirtyHedgeAmount: false,
            clickConfirm: false,
            model: {
                errorMessage: null
            },
            isConfirm: false,
            minStHome: IConstants.WEB_LINK.MIN_ST_HOME,
            input: {
                dispersion: 0,
                hedge: 0,
                hedgeAmount: 0,
                hedgeType: 0,
                maxLossAmount: '',
                shortTerm: 0,
            },
            mapSeflAssetsAmount: [],
            customerInfoView: null,
            selfAsset: null,
            listFinalAssets: null,
            errorMessageRequired: null,
            errorMessageSelfAssets: null,
            hedgeType: null,
            hedgeAmount: null,
            hasBoAgeLimit: null,
            hasUserBirthDay: true,
            telephoneNumber: null
        }
    },
    mixins: [offModalEvent, postDocTemplateMixin],
    validations: {
        input: {
            hedgeType: {
                required: requiredIf(function () {
                    return this.input.hedge === '1';
                })
            },
            hedgeAmount: {
                required: requiredIf(function () {
                    return this.input.hedge === '1';
                })
            },
            maxLossAmount: {
                required
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm[NEWS_TYPE.FORCE_SET_AGREE_FLG](true);
            vm[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](false);
        });
    },
    beforeRouteLeave(to, from, next) {
        this[NEWS_TYPE.FORCE_SET_AGREE_FLG](false);
        this[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](true);
        next();
    },
    mounted() {
        this.initBoRegist();
        this.afterCloseInformModal();
    },
    watch: {
        telephone(val) {
            this.telephoneNumber = val;
        }
    },
    destroyed() {
        this.offEventName(this.IConstants.EVENT_NAME.CLOSE_INFORM_MODAL);
    },
    methods: {
        ...mapHeaderAction([HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN]),
        ...mapNewsActions([NEWS_TYPE.FORCE_SET_AGREE_FLG]),

        btnSelectClick(event) {
            $(event.target).parents('.right-part').toggleClass('selected');
            $(event.target).toggleClass('selected');
            $(event.target).parents(".box-item").toggleClass('answered');
            this.checkhasquestion();
        },
        btnDefaultClick(event) {
            $(event.target).parents('.right-part').removeClass('selected');
            $(event.target).parents(".box-item").removeClass('answered');
            $(event.target).parents('.right-part').find('.btn-select').removeClass('selected');
            this.checkhasquestion();
        },

        async initBoRegist() {
            await this.$service.getService(this.SERVICE_NAME).initBoRegister().then(async (data) => {
                this.mapSeflAssetsAmount = data.mapBoMaxLossAmount;
                this.hasBoAgeLimit = data.ageLimit;
                this.hasUserBirthDay = data.hasUserBirthDay;
                await this.$service.getService("profile").getAmsCustomerInfo(IConstants.ACTIVE_MASKING.NO).then((response) => {
                    this.customerInfoView = response.amsCustomerInfoView;
                    this.selfAsset = this.customerInfoView.investmentAmount;
                    let listAssets = [];
                    let finalAssets = 0;
                    for (finalAssets in IConstants.listFinalAssets) {
                        if (parseFloat(finalAssets) <= this.selfAsset) {
                            let assets = {};
                            assets.key = IConstants.listFinalAssets[finalAssets].key;
                            assets.value = IConstants.listFinalAssets[finalAssets].value;
                            listAssets.push(assets);
                        }
                    }
                    this.listFinalAssets = listAssets;
                    this.listFinalAssets.unshift({
                        "key": "",
                        value: "profile.label.please_select"
                    });
                    if (this.customerInfoView.boLossMaxAmount && this.customerInfoView.boLossMaxAmount !== "") {
                        let amt = this.customerInfoView.boLossMaxAmount.replace(/[^0-9.]/g, '');
                        this.input.maxLossAmount = Number(amt);
                        this.input.shortTerm = this.customerInfoView.boInvestmentPurposeView.boPurposeShortTermFlg;
                        this.input.dispersion = this.customerInfoView.boInvestmentPurposeView.boPurposeDispAssetMngFlg;
                        this.input.hedge = this.customerInfoView.boInvestmentPurposeView.boPurposeHedgeFlg;
                        if (this.input.hedge === '1') {
                            this.input.hedgeAmount = this.customerInfoView.boPurposeHedgeAmount;
                            this.input.hedgeType = this.customerInfoView.boPurposeHedgeType;
                        }
                    }
                    this.isSelectBoInvest();
                });
            });
            const params = {
                hasBoAgeLimit: this.hasBoAgeLimit,
                hasUserBirthDay: this.hasUserBirthDay,
                telephone: this.telephone ? this.telephone : this.telephoneNumber
            }
            
            if (this.hasBoAgeLimit !== null || !this.hasUserBirthDay) {
                this.$modal.showBoAgeLimitMsg(params);
                return this.$router.push({name: "index"});
            }
        },
        openCancelModal() {
            this.$modal.openBoRegistrationCancelModal();
        },
        isSelectBoInvest() {
            let result = true;
            if (this.input.hedge !== '1') {
                this.input.hedgeType = '';
                this.input.hedgeAmount = '';
            }
            if (this.input.shortTerm !== '1' && this.input.dispersion !== '1' && this.input.hedge !== '1') {
                this.errorMessageRequired = "MSG_TRS_NAF_0004";
                result = false;
            } else {
                this.errorMessageRequired = null;
            }
            return result;
        },
        invalidSelfAssets() {
            let boMaxLossAmount = this.input.maxLossAmount;
            if (!boMaxLossAmount || boMaxLossAmount === '') {
                return true;
            }
            if (this.input.shortTerm !== '1' && this.input.dispersion !== '1' && this.input.hedge !== '1') {
                return true;
            }
            if (this.input.hedge === '1') {
                if (this.input.hedgeType === "") {
                    return true;
                }
                if (this.input.hedgeAmount === '') {
                    return true;
                }
            }
            let amsMaxLossAmountValue = this.$options.filters.getByPropertyName('asserts', this.selfAsset, this.mapSeflAssetsAmount).value;
            if (boMaxLossAmount > amsMaxLossAmountValue) {
                this.errorMessageSelfAssets = ServiceUtils.getMessageMaxAmountError(amsMaxLossAmountValue);
                return true;
            } else {
                this.errorMessageSelfAssets = null;
            }
            return false;
        },
        cancel() {
            this.$router.push({name: "home"})
        },
        confirmRegist() {
            this.clickConfirm = true;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                if (this.invalidSelfAssets()) {
                    return;
                }
                const config = new FormData();
                config.append("condition.dispersion", this.input.dispersion);
                config.append("condition.hedge", this.input.hedge);
                config.append("condition.hedgeAmount", this.input.hedgeAmount);
                config.append("condition.hedgeType", this.input.hedgeType);
                config.append("condition.maxLossAmount", this.input.maxLossAmount);
                config.append("condition.shortTerm", this.input.shortTerm);
                this.$service.getService(this.SERVICE_NAME).confirmBoRegister(config).then((response) => {
                    window.scrollTo(0, 0);
                    this.model = response;
                    if (!response.errorMessage) {
                        this.isConfirm = true;
                        if (this.input.hedge) {
                            this.hedgeType = this.$options.filters.getByPropertyName('key', this.input.hedgeType, this.mapHedgeType).value;
                            this.hedgeAmount = this.$options.filters.getByPropertyName('key', this.input.hedgeAmount, this.listFinalAssets).value;
                        }
                    }
                });
            }
        },
        saveRegist() {
            const config = new FormData();
            config.append("condition.dispersion", this.input.dispersion);
            config.append("condition.hedge", this.input.hedge);
            config.append("condition.hedgeAmount", this.input.hedgeAmount);
            config.append("condition.hedgeType", this.input.hedgeType);
            config.append("condition.maxLossAmount", this.input.maxLossAmount);
            config.append("condition.shortTerm", this.input.shortTerm);
            this.$service.getService(this.SERVICE_NAME).saveBoRegister(config).then((response) => {
                this.model = response;
                if (!response.errorMessage) {
                    this.$modal.openInformModal("trs.front.bo.registration.label.success");
                }
            });
        },
        changeDirtyHedgeType() {
            if (this.dirtyHedgeType === false) this.dirtyHedgeType = true;
        },
        changeDirtyHedgeAmount() {
            if (this.dirtyHedgeAmount === false) this.dirtyHedgeAmount = true;
        },
        checkhasquestion() {
            let allanswered = true;
            $(".box-item").each(function () {
                if (!$(this).hasClass('answered')) {
                    allanswered = false;
                }
            });
            if (allanswered) {
                $("#btnSave").addClass("allanswered btn-success");
                $("#btnSave").removeAttr("disabled");
            } else {
                $("#btnSave").removeClass("allanswered btn-success");
                $("#btnSave").prop('disabled', true);
            }
        },
        backToInput() {
            this.isConfirm = false;
            this.clickConfirm = false;
        },
        afterCloseInformModal() {
            ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_INFORM_MODAL, () => {
                if (this.model.boRegistrationInfoView.boStatus && this.model.boRegistrationInfoView.boStatus === "7") {
                    if (this.model.boRegistrationInfoView.boTestStatus && (this.model.boRegistrationInfoView.boTestStatus === "2" || this.model.boRegistrationInfoView.boTestStatus === "3")) {
                        this.$router.push({name: "boTest"});
                    } else {
                        this.$router.push({name: "home"})
                    }
                } else {
                    this.$router.push({name: "home"})
                }
            })
        }
    },
}
</script>

<style scoped>
  .btn-default{
    margin-left: 2px;
  }
  .btn-warning {
    margin-right: 2px;
    color: white !important;
  }
  .clear-both{
    clear: both;
  }

  .f-s-14{
    font-size: 14px;
  }
  .container-bo-register {
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: 1200px) {
    .container-bo-register {
      width: 1140px;
    }
  }
  
  @media (max-width: 767px) {
    .mr-1{
      margin-right: 0;
    }
    .ml-1{
      margin-left: 0;
    }
  }
</style>
